module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACzSURBVHgBtZRBEsQQEEW7VXEO17DMybO0cYdxDhbGT9VUTSUkTUlvEvp7Gh8OIXyYmVJKm3Mu0kR4763WegdHoaOUYo0xOxI0GD9Y/bVoq5zzVr9xBvoPq9VFrJJ7iafl98bwk2AEhhxLhVINj8wumfAC7A1Ev2RLmsAWtLqASLC/XeAZeogFDlC0OJSkOlRGQvO/fyhLbbPU2Euv3tLHYQZ2B1WzMAS05/f08OEMrAVF+wsMPyBuTBtCYgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/renew_mobile/close_btn.png
// module id = IvLm
// module chunks = 0